import { render, staticRenderFns } from "./miniCard.vue?vue&type=template&id=266aefa7&scoped=true"
import script from "./miniCard.vue?vue&type=script&lang=js"
export * from "./miniCard.vue?vue&type=script&lang=js"
import style0 from "./miniCard.vue?vue&type=style&index=0&id=266aefa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266aefa7",
  null
  
)

export default component.exports